webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(67);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(65);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(64);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _App = __webpack_require__(45);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _swiperMin = __webpack_require__(42);
	
	var _swiperMin2 = _interopRequireDefault(_swiperMin);
	
	var _singlePost = __webpack_require__(52);
	
	var _singlePost2 = _interopRequireDefault(_singlePost);
	
	var _singlePostYear = __webpack_require__(53);
	
	var _singlePostYear2 = _interopRequireDefault(_singlePostYear);
	
	var _Indexpage = __webpack_require__(46);
	
	var _Indexpage2 = _interopRequireDefault(_Indexpage);
	
	var _Getgradyears = __webpack_require__(2);
	
	var _Getgradyears2 = _interopRequireDefault(_Getgradyears);
	
	var _vueLazyload = __webpack_require__(44);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.prototype.$apiUrl = 'https://meia.pzwart.nl/backend/wp-json/';
	
	var vueSmoothScroll = __webpack_require__(66);
	_vue2.default.use(vueSmoothScroll);
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	
	_vue2.default.use(_vueLazyload2.default, {
	  preLoad: 1.3,
	  attempt: 1,
	  listenEvents: ['scroll']
	});
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	
	  routes: [{
	    path: '/',
	    name: 'home',
	
	    component: _Indexpage2.default,
	
	    children: [{
	      name: 'work',
	      path: 'work/:id',
	      component: _singlePost2.default
	
	    }, {
	      name: 'year',
	      path: 'year/:yearCategory',
	      component: _singlePostYear2.default
	
	    }, {
	      name: 'yearview',
	
	      path: 'yearview/:years',
	      component: _Indexpage2.default
	
	    }]
	
	  }],
	
	  scrollBehavior: function scrollBehavior(to, from) {
	    var scrolltop = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0);
	    console.log(scrolltop);
	    if (to.name == 'year' || to.name == 'work') {
	      window.scrollTo(0, 0);
	      console.log('not home');
	    }
	  }
	});
	
	new _vue2.default({
	  router: router,
	  components: {},
	  template: '\n    <div id="app">\n      <router-view></router-view>\n    </div>\n  '
	}).$mount('#app');

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(37)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(63),
	  /* scopeId */
	  "data-v-e926a730",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(22)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(7),
	  /* template */
	  __webpack_require__(55),
	  /* scopeId */
	  "data-v-228797af",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'app',
	  components: {}
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Listposts = __webpack_require__(3);
	
	var _Listposts2 = _interopRequireDefault(_Listposts);
	
	var _Splashposts = __webpack_require__(48);
	
	var _Splashposts2 = _interopRequireDefault(_Splashposts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Listposts: _Listposts2.default,
	    Splashposts: _Splashposts2.default
	  },
	  data: function data() {
	    return {
	      hover: false,
	      yearWrapperHeight: [],
	      gradyears: [],
	      collapsed: [],
	      ListpostId: 'iddd',
	      indexLoaded: false,
	      homeVisited: false,
	      collapseAll: false
	    };
	  },
	
	  created: function created() {
	
	    if (this.gradyears.length === 0) {
	      this.$http.get(this.$apiUrl + 'wp/v2/categories?slug=graduation-years').then(function (response) {
	        var graduationYearsId = response.body[0].id;
	        this.$http.get(this.$apiUrl + 'wp/v2/categories?parent=' + graduationYearsId + '&per_page=100').then(function (response) {
	          this.gradyears = response.body;
	          this.attachExtras();
	          this.goToYear(parseInt(this.$route.query.yearview));
	        });
	      });
	    }
	  },
	  computed: {
	    listHeightText: function listHeightText() {}
	  },
	
	  watch: {
	    '$route': function $route(to, from) {
	
	      if (to.path === '/' && this.homeVisited === false && from.path !== '/') {
	        this.indexLoaded = false;
	        this.stopIndexLoad();
	      }
	
	      if (to.path === '/') {
	        this.goToYear(parseInt(to.query.yearview));
	      }
	
	      if (from.path === '/') {
	        this.homeVisited = true;
	      }
	    }
	  },
	
	  methods: {
	
	    goToYear: function goToYear(id) {
	      if (this.$route.query.yearview) {
	        for (var i = 0; i < this.gradyears.length; i++) {
	          if (i === id) {
	            this.$set(this.collapsed, i, false);
	          } else {
	
	            this.$set(this.collapsed, i, true);
	          }
	        }
	      }
	    },
	
	    stopIndexLoad: function stopIndexLoad() {
	      var vm = this;
	      setTimeout(function () {
	        vm.indexLoaded = true;
	      }, 500);
	    },
	    attachExtras: function attachExtras() {
	      var vueInstance = this;
	
	      for (var i = 0; i < this.gradyears.length; i++) {
	        if (i != this.gradyears.length - 1) {
	          this.collapsed.push(true);
	        } else {
	          this.collapsed.push(false);
	        }
	      }
	    },
	
	    clickNext: function clickNext(index, yearNumber) {
	      this.$set(this.collapsed, index, true);
	      this.$set(this.collapsed, index + 1, false);
	      this.$SmoothScroll(0, 500);
	
	      this.$router.push({
	        query: {
	          yearview: index + 1
	        }
	      });
	    },
	
	    clickCollapseAll: function clickCollapseAll(index) {
	      this.collapseAll = index;
	      console.log(this.collapseAll);
	      var vm = this;
	      setTimeout(function () {
	        vm.collapseAll = 'x';
	      }, 1);
	    },
	    clickPrev: function clickPrev(index, yearNumber) {
	
	      this.$set(this.collapsed, index, true);
	      this.$set(this.collapsed, index - 1, false);
	      this.$SmoothScroll(0, 500);
	
	      this.$router.push({
	        query: {
	          yearview: index - 1
	        }
	      });
	    }
	
	  },
	
	  mounted: function mounted() {}
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Getgradyears = __webpack_require__(2);
	
	var _Getgradyears2 = _interopRequireDefault(_Getgradyears);
	
	var _meiaFooter = __webpack_require__(49);
	
	var _meiaFooter2 = _interopRequireDefault(_meiaFooter);
	
	var _meiaHeader = __webpack_require__(50);
	
	var _meiaHeader2 = _interopRequireDefault(_meiaHeader);
	
	var _meiaNews = __webpack_require__(51);
	
	var _meiaNews2 = _interopRequireDefault(_meiaNews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Getgradyears: _Getgradyears2.default,
	    meiaFooter: _meiaFooter2.default,
	    meiaHeader: _meiaHeader2.default,
	    meiaNews: _meiaNews2.default
	  },
	
	  data: function data() {
	    return {
	      showIndex: true,
	      showNews: false,
	      loaded: false,
	      showIndexFirst: false
	    };
	  },
	
	  watch: {
	
	    '$route': function $route(newRoute, oldRoute) {
	      if (this.$route.path.toString() === "/") {
	        this.showIndex = true;
	        this.showIndexFirst = true;
	      } else {
	        this.showIndexFirst = true;
	        this.showIndex = false;
	      }
	
	      setTimeout(function () {
	        window.fitText(document.querySelectorAll('.splashTitle'));
	      }, 1);
	    }
	  },
	
	  name: 'indexpage',
	
	  beforeMount: function beforeMount() {
	    if (this.$route.path.toString() != "/") {
	      this.showIndex = false;
	    }
	  },
	
	  methods: {
	    alertthis: function alertthis() {
	      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx');
	    },
	    toggleNews: function toggleNews() {
	      this.showNews = !this.showNews;
	    }
	  },
	  created: function created() {
	    this.loaded = true;
	  }
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Listposts = __webpack_require__(3);
	
	var _Listposts2 = _interopRequireDefault(_Listposts);
	
	var _Singlepostindex = __webpack_require__(47);
	
	var _Singlepostindex2 = _interopRequireDefault(_Singlepostindex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['categoryyear', 'categorylink', 'indexGradyears', 'yearColor', 'parentId', 'collapseAll', 'yearview'],
	  components: {
	    Listposts: _Listposts2.default,
	    Singlepostindex: _Singlepostindex2.default
	  },
	  data: function data() {
	    return {
	      hidePostList: false,
	
	      projects: [],
	      featuredimages: [],
	      worktitles: [],
	      workids: [],
	      workstudents: []
	    };
	  },
	
	  created: function created() {
	
	    if (this.projects.length === 0) {
	      this.$http.get(this.categorylink).then(function (response) {
	        this.projects = response.body;
	
	        for (var i = 0; i < this.projects.length; i++) {
	
	          this.workids.push(this.projects[i].id);
	
	          if (this.projects[i].acf) {
	
	            this.worktitles.push(this.projects[i].title.rendered);
	            this.workstudents.push(this.projects[i].acf.student_name);
	
	            if (this.projects[i].acf.featuredimage) {
	
	              this.featuredimages.push({
	                large: this.projects[i].acf.featuredimage.sizes.large
	              });
	            }
	          }
	        }
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    this.attachExtraStyle();
	
	    this.$emit('stopIndexLoad');
	  },
	
	  methods: {
	    toggleHidePostList: function toggleHidePostList() {
	      this.hidePostList = !this.hidePostList;
	    },
	
	    attachExtraStyle: function attachExtraStyle() {
	
	      var vm = this;
	
	      document.head.insertAdjacentHTML('beforeend', '<style>\n              #' + this.$el.getAttribute('id') + ' .single:first-child .singleRealTitle:hover {\n                          border-top: 1px solid ' + this.yearColor + ';\n              }\n              #' + this.$el.getAttribute('id') + ' .single:first-child .singleRealName:hover {\n                          border-top: 1px solid ' + this.yearColor + ';\n              }\n\n              #' + this.$el.getAttribute('id') + ' .single .singleRealTitle:hover {\n                          color:' + this.yearColor + ';\n              }\n              #' + this.$el.getAttribute('id') + ' .single .singleRealName:hover {\n                          color:' + this.yearColor + ';\n              }\n\n              #' + this.$el.getAttribute('id') + ' .singleContent .singleContentInnerLeftLink:hover {\n                          color:' + this.yearColor + ';\n              }\n              #' + this.$el.getAttribute('id') + ' .singleContent .singleContentInnerLeftLink span:hover {\n                          color:' + this.yearColor + ';\n              }\n\n\n              #' + this.$el.getAttribute('id') + ' .singleContent .singleContentInnerLink:hover {\n                          color:' + this.yearColor + ';\n              }\n\n\n              .singleContentInner:hover {\n                          background:' + this.yearColor + ';\n                        \n\n              }\n\n          </style>');
	    }
	
	  }
	};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fittext = __webpack_require__(16);
	
	var _fittext2 = _interopRequireDefault(_fittext);
	
	var _lodash = __webpack_require__(39);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _documentOffset = __webpack_require__(17);
	
	var _documentOffset2 = _interopRequireDefault(_documentOffset);
	
	var _alert = __webpack_require__(15);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'singlepostindex',
	  props: ['title', 'fulltitle', 'index', 'projectslength', 'id', 'workstudent', 'yearColor', 'collapseAll', 'yearview'],
	  data: function data() {
	    return {
	      showSingle: false,
	      nameWidth: 0,
	      closeWidth: 0,
	      postJsonContent: "",
	      linkLineHeight: 40,
	      postJsonContentFeaturedImageWidth: 0,
	      postJsonContentFeaturedImage: "",
	      postJsonContentFeaturedImageLoaded: false,
	      featuredImageCalculatedHeight: '',
	      name: ['Shemeka Mccullar', 'Craig Falgout', 'Pia Kos', 'Trish Staten', 'Dionna Gerber', 'Lilian Sano', 'Emmitt Casebeer', 'Jeanine Mollica', 'Preston Rouleau']
	    };
	  },
	
	  methods: {
	    expandSingle: function expandSingle(id) {
	
	      this.showSingle = !this.showSingle;
	
	      this.$http.get(this.$apiUrl + 'wp/v2/yearpost/' + id + '?per_page=100').then(function (response) {
	
	        this.postJsonContent = response.body.acf.excerpt_field;
	        if (response.body.acf.featuredimage) {
	          this.postJsonContentFeaturedImage = response.body.acf.featuredimage.sizes.large;
	          this.postJsonContentFeaturedImageWidth = this.$el.querySelector('.singleContentInnerFeatured').clientWidth;
	          this.postJsonContentFeaturedImageRelation = response.body.acf.featuredimage.sizes['large-height'] / response.body.acf.featuredimage.sizes['large-width'];
	        }
	        if (this.showSingle) {
	          console.log((0, _documentOffset2.default)(document.getElementById(this.id)).top);
	
	          this.closeWidth = this.$el.getElementsByClassName('close')[0].clientWidth + 1;
	          console.log(this.closeWidth);
	          if (this.closeWidth < 100) {
	
	            this.$SmoothScroll((0, _documentOffset2.default)(this.$el).top - this.closeWidth - 3, 500);
	          } else {
	            this.$SmoothScroll((0, _documentOffset2.default)(this.$el).top - this.closeWidth + 35, 500);
	          }
	
	          if (this.postJsonContentFeaturedImage) {
	            this.lazyLoadHandleLoaded();
	            this.lazyLoadHandleLoading();
	          }
	        }
	      });
	    },
	
	    fitReadmore: function fitReadmore() {
	      var vm = this;
	      if (window.innerWidth > 800) {
	        setTimeout(function () {
	          vm.linkLineHeight = vm.$el.querySelector('.singleContent').clientHeight - vm.$el.querySelector('.singleContentInnerRenderedWrapper').clientHeight - 1;
	        }, 1000);
	      }
	    },
	
	    collapseSingle: function collapseSingle() {
	      this.showSingle = !this.showSingle;
	    },
	
	    lazyLoadHandleLoaded: function lazyLoadHandleLoaded() {
	      var vm = this;
	
	      this.$Lazyload.$once('loaded', function (_ref, formCache) {
	        var bindType = _ref.bindType,
	            el = _ref.el,
	            naturalHeight = _ref.naturalHeight,
	            naturalWidth = _ref.naturalWidth,
	            $parent = _ref.$parent,
	            src = _ref.src,
	            loading = _ref.loading,
	            error = _ref.error;
	
	        vm.fitReadmore();
	        vm.postJsonContentFeaturedImageLoaded = true;
	        setTimeout(function () {
	          vm.postJsonContentFeaturedImageLoaded = true;
	        }, 100);
	        setTimeout(function () {
	          vm.postJsonContentFeaturedImageLoaded = true;
	        }, 250);
	        setTimeout(function () {
	          vm.postJsonContentFeaturedImageLoaded = true;
	        }, 500);
	
	        vm.featuredImageCalculatedHeight = 'initial';
	      });
	    },
	
	    lazyLoadHandleLoading: function lazyLoadHandleLoading() {
	      var vm = this;
	
	      this.$Lazyload.$once('loading', function (_ref2, formCache) {
	        var bindType = _ref2.bindType,
	            el = _ref2.el,
	            naturalHeight = _ref2.naturalHeight,
	            naturalWidth = _ref2.naturalWidth,
	            $parent = _ref2.$parent,
	            src = _ref2.src,
	            loading = _ref2.loading,
	            error = _ref2.error;
	
	
	        vm.featuredImageCalculatedHeight = vm.postJsonContentFeaturedImageRelation * vm.postJsonContentFeaturedImageWidth + 'px';
	      });
	    },
	
	    fitTitles: function fitTitles() {
	      this.nameWidth = this.$el.getElementsByClassName('singleRealName')[0].clientWidth + 1;
	      var vm = this;
	      setTimeout(function () {
	        if (vm.title.length <= 14) {
	          window.fitText(document.getElementById('title' + vm.id), vm.title.length / 20);
	        }
	
	        if (vm.title.length > 14 && vm.title.length <= 18) {
	          window.fitText(document.getElementById('title' + vm.id), vm.title.length / 14);
	        }
	
	        if (vm.title.length > 18 && vm.title.length <= 24) {
	          window.fitText(document.getElementById('title' + vm.id), vm.title.length / 9);
	        }
	        if (vm.title.length > 24 && vm.title.length <= 32) {
	          window.fitText(document.getElementById('title' + vm.id), vm.title.length / 7);
	        }
	
	        if (vm.title.length > 32 && vm.title.length <= 40) {
	          window.fitText(document.getElementById('title' + vm.id), vm.title.length / 6);
	        }
	
	        if (vm.title.length > 40 && vm.title.length <= 60) {
	          window.fitText(document.getElementById('title' + vm.id), vm.title.length / 4);
	        }
	
	        if (vm.title.length > 60) {
	          window.fitText(document.getElementById('title' + vm.id), vm.title.length / 2);
	        }
	      }, 1);
	    },
	
	    handleResize: _lodash2.default.throttle(function () {
	      this.fitTitles();
	      if (this.$el.getElementsByClassName('close')[0] != null) {
	        this.closeWidth = this.$el.getElementsByClassName('close')[0].clientWidth + 1;
	      }
	    }, 0)
	
	  },
	  computed: {
	    pickRandomName: function pickRandomName() {
	      name = this.name[Math.floor(Math.random() * this.name.length)];
	      return name;
	    },
	
	    addTitleLengthClass: function addTitleLengthClass() {
	
	      if (this.title.length <= 20) {
	        return 'large';
	      }
	      if (this.title.length < 50 && this.title.length > 20) {
	        return 'mid';
	      }
	      if (this.title.length > 50) {
	        return 'small';
	      }
	    }
	  },
	  mounted: function mounted() {
	
	    this.fitTitles();
	    var vm = this;
	    window.addEventListener("load", function load(event) {
	      window.removeEventListener("load", load, false);
	      vm.fitTitles();
	    }, false);
	    window.setTimeout(function () {
	      vm.fitTitles();
	      window.setTimeout(function () {
	        vm.fitTitles();
	        window.setTimeout(function () {
	          vm.fitTitles();
	        }, 500);
	      }, 500);
	    }, 500);
	
	    var vm = this;
	    window.addEventListener('resize', function () {
	      vm.handleResize();
	    });
	  },
	
	  watch: {
	
	    collapseAll: function collapseAll() {
	      if (this.collapseAll === this.yearview) {
	        this.showSingle = false;
	      }
	    },
	    '$route': function $route(to, from) {
	
	      if (to.path === '/') {
	        this.fitTitles();
	        var vm = this;
	
	        window.setTimeout(function () {
	          vm.fitTitles();
	          window.setTimeout(function () {
	            vm.fitTitles();
	            window.setTimeout(function () {
	              vm.fitTitles();
	            }, 500);
	          }, 500);
	        }, 500);
	      }
	    }
	  },
	  created: function created() {}
	
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['categorylink', 'listpostId', 'yearColor', 'year', 'yearviewIndex'],
	  components: {},
	
	  data: function data() {
	    return {
	      hidePostList: false,
	      yearTitle: '',
	      featuredimageSplash: '',
	      splashExcerpt: '',
	      splashProgramme: '',
	      showSplash: true,
	      expandedProgramme: false
	    };
	  },
	
	  created: function created() {
	    this.$http.get(this.categorylink).then(function (response) {
	      if (response.body.length > 0) {
	        this.yearTitle = response.body[0].title.rendered;
	        this.featuredimageSplash = response.body[0].acf.featuredimage;
	        this.splashExcerpt = response.body[0].acf.excerpt;
	        this.splashProgramme = response.body[0].acf.programme;
	        window.fitText(this.$el.querySelector('.splashTitle'));
	      }
	    });
	  },
	
	  methods: {
	    expandSplash: function expandSplash(id) {
	      this.showSplash = !this.showSplash;
	    },
	
	    collapseSplash: function collapseSplash() {
	      this.showSplash = !this.showSplash;
	    },
	    goToGraduates: function goToGraduates() {
	      this.$SmoothScroll(document.getElementById(this.listpostId).offsetTop - 79, 250);
	    }
	
	  }
	};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      about: '',
	      colophon: ''
	    };
	  },
	
	
	  methods: {
	    getContent: function getContent(yearCategory) {
	
	      this.$http.get(this.$apiUrl + 'wp/v2/pages?per_page=100').then(function (response) {
	        this.about = response.body[0].acf.about;
	        this.colophon = response.body[0].acf.colophon;
	      });
	    }
	  },
	  created: function created() {
	    this.getContent(this.$route.params.yearCategory);
	  }
	
	};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  methods: {
	    emitToggleNews: function emitToggleNews() {
	      this.$emit('emitToggleNews');
	    },
	    goToBottom: function goToBottom() {
	      this.$SmoothScroll(document.getElementById('footer').offsetTop - 40, 500);
	    }
	  }
	};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    expandedActive: {
	      type: Boolean,
	      default: false
	    }
	  }
	};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  props: ['showIndex', 'loaded', 'showIndexFirst'],
	
	  methods: {
	
	    goBack: function goBack() {
	      this.$router.go(-1);
	    },
	
	    goBackNone: function goBackNone() {
	
	      setTimeout(function () {
	        window.scrollTo(0, 0);
	      }, 500);
	      this.$router.push({ path: '/', query: { yearview: this.yearviewquery } });
	    },
	    getContent: function getContent(id) {
	
	      this.$http.get(this.$apiUrl + 'wp/v2/yearpost/' + id + '?per_page=100').then(function (response) {
	        if (this.postJsonContent.length === 0) {
	          this.postJsonContent = response.body.acf.text_field;
	          this.postJsonTitle = response.body.title.rendered;
	          this.postJsonStudent = response.body.acf.student_name;
	          this.postJsonContentMedia = response.body.acf.media_field;
	          this.postJsonAttachedField = response.body.acf.attachment_field;
	          this.postJsonThesis = response.body.acf.attach_thesis.length > 0 ? true : false;
	          this.postJsonThesisUploaded = response.body.acf.thesis_field_choice === "Upload file" ? true : false;
	          this.postJsonThesisFile = response.body.acf.thesis_field_file;
	          this.postJsonThesisLink = response.body.acf.thesis_field_link;
	
	          this.$http.get(this.$apiUrl + 'wp/v2/categories/' + response.body.categories[0] + '?per_page=100').then(function (response) {
	            this.year = response.body.name;
	            this.yearColor = response.body.acf.yearcolor;
	            var vm = this;
	            setTimeout(function () {
	              vm.singleLoaded = true;
	            }, 500);
	
	            this.yearviewquery = this.$route.query.yearview;
	          });
	        }
	      });
	    }
	  },
	  created: function created() {
	
	    this.getContent(this.$route.params.id);
	  },
	
	  data: function data() {
	    return {
	      postJsonContent: '',
	      postJsonTitle: '',
	      postJsonStudent: '',
	      postJsonContentMedia: '',
	      postJsonAttachedField: [],
	      yearviewquery: '',
	      year: '',
	      yearColor: '',
	      singleLoaded: false
	    };
	  }
	};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  props: {
	    showIndex: {
	      type: Boolean,
	      default: true
	    },
	    showIndexFirst: {
	      type: Boolean
	    }
	  },
	
	  methods: {
	
	    goBack: function goBack() {
	      this.$router.go(-1);
	    },
	
	    goBackNone: function goBackNone() {
	
	      setTimeout(function () {
	        window.scrollTo(0, 0);
	      }, 500);
	      this.$router.push({
	        path: '/',
	        query: {
	          yearview: this.yearviewquery
	        }
	      });
	    },
	
	    getContent: function getContent(yearCategory) {
	
	      this.$http.get(this.$apiUrl + 'wp/v2/categories?search=' + yearCategory).then(function (response) {
	        this.$http.get(response.body[0]._links['wp:post_type'][1].href).then(function (response) {
	          this.postJsonContent = response.body[0].acf.text_field;
	          this.postJsonTitle = response.body[0].title.rendered;
	          this.splashExcerpt = response.body[0].acf.excerpt;
	          this.postJsonContentMedia = response.body[0].acf.media_field;
	          this.postJsonContentFullSize = response.body[0].acf.full_size;
	          this.yearTitleSkew = response.body[0].acf.title_skew.toString();
	          this.yearTitleRotate = response.body[0].acf.title_rotate.toString();
	
	          window.fitText(this.$el.querySelector('.splashTitle'));
	
	          this.$http.get(this.$apiUrl + 'wp/v2/categories/' + response.body[0].categories[0]).then(function (response) {
	            this.year = response.body.name;
	            this.yearColor = response.body.acf.yearcolor;
	
	            var vm = this;
	            setTimeout(function () {
	              vm.singleLoaded = true;
	            }, 500);
	            this.yearviewquery = this.$route.query.yearview;
	          });
	        });
	      });
	    }
	  },
	  created: function created() {
	    this.getContent(this.$route.params.yearCategory);
	  },
	
	  data: function data() {
	    return {
	      postJsonContent: '',
	      postJsonTitle: '',
	      postJsonContentMedia: '',
	      postJsonContentFullSize: '',
	      year: '',
	      splashExcerpt: '',
	      yearColor: '',
	      singleLoaded: false,
	      yearviewquery: '',
	      yearTitleRotate: '0',
	      yearTitleSkew: '0'
	    };
	  }
	};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  window.testerAlert = function () {
	
	    console.log('alertt!');
	    alert('alertt!');
	  };
	})();

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	
	  var addEvent = function addEvent(el, type, fn) {
	    if (el.addEventListener) el.addEventListener(type, fn, false);else el.attachEvent('on' + type, fn);
	  };
	
	  var extend = function extend(obj, ext) {
	    for (var key in ext) {
	      if (ext.hasOwnProperty(key)) obj[key] = ext[key];
	    }return obj;
	  };
	
	  window.fitText = function (el, kompressor, options) {
	
	    var settings = extend({
	      'minFontSize': 32,
	      'maxFontSize': 64
	    }, options);
	
	    var settingsMobile = extend({
	      'minFontSize': 12,
	      'maxFontSize': 32
	    }, options);
	
	    var fit = function fit(el) {
	      var compressor = kompressor || 1;
	
	      var resizer = function resizer() {
	        if (window.innerWidth > 800) {
	          el.style.fontSize = Math.max(Math.min(el.clientWidth / (compressor * 10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)) + 'px';
	        } else {
	          el.style.fontSize = Math.max(Math.min(el.clientWidth / (compressor * 10), parseFloat(settingsMobile.maxFontSize)), parseFloat(settingsMobile.minFontSize)) + 'px';
	        }
	      };
	
	      resizer();
	
	      addEvent(window, 'resize', resizer);
	      addEvent(window, 'orientationchange', resizer);
	    };
	
	    if (el.length) for (var i = 0; i < el.length; i++) {
	      fit(el[i]);
	    } else fit(el);
	
	    return el;
	  };
	})();

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(32)
	__webpack_require__(34)
	__webpack_require__(33)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(4),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(31)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(6),
	  /* template */
	  __webpack_require__(61),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(26)
	__webpack_require__(25)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(8),
	  /* template */
	  __webpack_require__(57),
	  /* scopeId */
	  "data-v-2f0b16a4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(24)
	__webpack_require__(23)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(9),
	  /* template */
	  __webpack_require__(56),
	  /* scopeId */
	  "data-v-2623a0f4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(30)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(10),
	  /* template */
	  __webpack_require__(60),
	  /* scopeId */
	  "data-v-7034f601",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(35)
	__webpack_require__(36)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(11),
	  /* template */
	  __webpack_require__(62),
	  /* scopeId */
	  "data-v-dd314c1a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(29)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(12),
	  /* template */
	  __webpack_require__(59),
	  /* scopeId */
	  "data-v-6204eab9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(21)
	__webpack_require__(20)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(13),
	  /* template */
	  __webpack_require__(54),
	  /* scopeId */
	  "data-v-0cbf1a1e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(28)
	__webpack_require__(27)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(14),
	  /* template */
	  __webpack_require__(58),
	  /* scopeId */
	  "data-v-5903260a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "singlePost"
	  }, [(!_vm.singleLoaded) ? _c('div', {
	    staticClass: "singleLoaded"
	  }, [_c('h1', {
	    staticClass: "headerElement"
	  }, [_vm._v("Loading")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "signlePostHeader",
	    style: ({
	      background: _vm.yearColor
	    })
	  }, [_c('span', {
	    staticClass: "headerElement"
	  }, [_vm._v("Work")]), _vm._v(" "), _c('span', {
	    staticClass: "headerElement alignCenter"
	  }, [_vm._v("Year"), _c('br', {
	    staticClass: "tabletView"
	  }), _vm._v(" " + _vm._s(_vm.year))]), _vm._v(" "), (_vm.showIndexFirst) ? _c('span', {
	    staticClass: "headerElement alignRight"
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.goBack()
	      }
	    }
	  }, [_vm._v("Back")])]) : _c('span', {
	    staticClass: "headerElement alignRight"
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.goBackNone()
	      }
	    }
	  }, [_vm._v("Back")])])]), _vm._v(" "), (_vm.singleLoaded) ? _c('div', {
	    staticClass: "postcontentWrapper",
	    style: ({
	      background: _vm.yearColor
	    })
	  }, [_c('div', {
	    staticClass: "left",
	    style: ({
	      background: _vm.yearColor
	    })
	  }, [_c('p', {
	    staticClass: "postcontentWrapperTitle"
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.postJsonStudent)
	    }
	  }), _c('br'), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.postJsonTitle)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "notTabletView",
	    domProps: {
	      "innerHTML": _vm._s(_vm.postJsonContentMedia)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "right",
	    style: ({
	      background: _vm.yearColor
	    })
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.postJsonContent)
	    }
	  }), _vm._v(" "), (_vm.postJsonThesis) ? _c('div', {
	    staticClass: "attachments"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v("\n          Thesis:\n        ")]), _vm._v(" "), _c('ul', [(_vm.postJsonThesisUploaded) ? _c('li', [_c('span', {
	    staticClass: "attachmentInner"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": _vm.postJsonThesisFile.url
	    }
	  }, [_vm._v("Download")])])]) : _c('li', [_c('span', {
	    staticClass: "attachmentInner"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": _vm.postJsonThesisLink
	    }
	  }, [_vm._v("Download")])])])])]) : _vm._e(), _vm._v(" "), (_vm.postJsonAttachedField) ? _c('div', {
	    staticClass: "attachments"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v("\n          Attachments:\n        ")]), _vm._v(" "), _c('ul', _vm._l((_vm.postJsonAttachedField), function(file) {
	    return _c('li', [_c('span', {
	      staticClass: "attachmentInner"
	    }, [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(file.prettytitle)
	      }
	    }), _vm._v(" "), _c('span', [_c('a', {
	      attrs: {
	        "href": file.attachments.url
	      }
	    }, [_vm._v("Download")])]), _vm._v(" "), _c('span', {
	      staticClass: "description",
	      domProps: {
	        "innerHTML": _vm._s(file.description)
	      }
	    })])])
	  }))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "tabletView paddedTop",
	    domProps: {
	      "innerHTML": _vm._s(_vm.postJsonContentMedia)
	    }
	  })])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "slideIn listSingle",
	    attrs: {
	      "id": "listPostWrapper"
	    }
	  }, [_c('div', {
	    staticClass: "listPostsWrapper",
	    class: {
	      collapsed: _vm.hidePostList
	    }
	  }, _vm._l((_vm.projects), function(project, index) {
	    return _c('singlepostindex', {
	      attrs: {
	        "yearview": _vm.yearview,
	        "collapseAll": _vm.collapseAll,
	        "yearColor": _vm.yearColor,
	        "index": _vm.indexGradyears,
	        "workstudent": _vm.workstudents[index],
	        "projectslength": _vm.projects.length,
	        "id": project.id,
	        "title": project.acf.shorttitle,
	        "fulltitle": project.title.rendered
	      }
	    })
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "splashPost",
	    class: {
	      expanded: _vm.showSplash
	    }
	  }, [_c('div', {
	    staticClass: "splashTextContentWrap"
	  }, [_c('div', {
	    staticClass: "titleWrap"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        path: 'year/' + _vm.year,
	        query: {
	          yearview: _vm.yearviewIndex
	        }
	      }
	    }
	  }, [_c('h1', {
	    staticClass: "splashTitle",
	    style: ({
	      color: this.yearColor
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.yearTitle)
	    }
	  })])], 1), _vm._v(" "), (_vm.featuredimageSplash) ? _c('div', {
	    staticClass: "blurbWrap",
	    style: ({
	      color: this.yearColor
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.splashExcerpt)
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "splashImage"
	  }, [(!_vm.featuredimageSplash) ? _c('div', {
	    staticClass: "blurbWrap",
	    style: ({
	      color: this.yearColor
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.splashExcerpt)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.featuredimageSplash) ? _c('div', {
	    staticClass: "splashImageInner"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.featuredimageSplash.sizes.large
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "navigationWrap",
	    style: ({
	      color: this.yearColor,
	      'border-color': this.yearColor
	    })
	  }, [_c('div', {
	    staticClass: "border-right singleContentInnerLinkOuter",
	    style: ({
	      'border-color': this.yearColor
	    }),
	    on: {
	      "click": function($event) {
	        _vm.goToGraduates()
	      }
	    }
	  }, [_c('span', [_vm._v("Graduates")])]), _vm._v(" "), _c('div', {
	    staticClass: "singleContentInnerLinkOuter",
	    style: ({
	      color: this.yearColor,
	      'border-color': this.yearColor
	    })
	  }, [(this.splashProgramme) ? [_c('div', {
	    staticClass: "singleContentInnerLink border-right",
	    style: ({
	      'border-color': this.yearColor
	    }),
	    on: {
	      "click": function($event) {
	        _vm.expandedProgramme = !_vm.expandedProgramme
	      }
	    }
	  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
	    staticClass: "singleContentInnerLink"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        path: 'year/' + _vm.year,
	        query: {
	          yearview: _vm.yearviewIndex
	        }
	      }
	    }
	  }, [_c('div', [_c('span', [_vm._v("Read More")])])])], 1)] : [_c('div', {}, [_c('router-link', {
	    attrs: {
	      "to": {
	        path: 'year/' + _vm.year,
	        query: {
	          yearview: _vm.yearviewIndex
	        }
	      }
	    }
	  }, [_c('div', [_c('span', [_vm._v("Read More")])])])], 1)]], 2)]), _vm._v(" "), (_vm.expandedProgramme) ? _c('div', {
	    staticClass: "splashProgramme",
	    style: ({
	      'color': this.yearColor,
	      'border-color': this.yearColor
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.splashProgramme)
	    }
	  }) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', [_c('span', [_vm._v("Programme")])])])
	}]}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "single",
	    attrs: {
	      "id": _vm.id
	    }
	  }, [_c('div', {
	    staticClass: "singleTitle",
	    on: {
	      "click": function($event) {
	        _vm.expandSingle(_vm.id)
	      }
	    }
	  }, [(!_vm.showSingle) ? [_c('h1', {
	    staticClass: "singleRealName",
	    style: ({}),
	    domProps: {
	      "innerHTML": _vm._s(_vm.workstudent)
	    }
	  }), _vm._v(" "), _c('h1', {
	    staticClass: "singleRealTitle",
	    class: _vm.addTitleLengthClass,
	    style: ({
	      width: 'calc(100% - ' + _vm.nameWidth + 'px)'
	    }),
	    attrs: {
	      "id": 'title' + _vm.id
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.title)
	    }
	  })] : [_c('h1', {
	    staticClass: "singleRealName singleExpanded",
	    style: ({
	      'border-top': '1px solid ' + _vm.yearColor,
	      color: _vm.yearColor
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.workstudent)
	    }
	  }), _vm._v(" "), _c('h1', {
	    staticClass: "singleRealTitle singleExpanded",
	    class: _vm.addTitleLengthClass,
	    style: ({
	      'border-top': '1px solid ' + _vm.yearColor,
	      color: _vm.yearColor,
	      'border-left': '1px solid ' + _vm.yearColor,
	      width: 'calc(100% - ' + (_vm.nameWidth + _vm.closeWidth) + 'px)'
	    }),
	    attrs: {
	      "id": 'title' + _vm.id
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.title)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "close"
	  })]], 2), _vm._v(" "), _c('div', {
	    staticClass: "singleContent",
	    class: {
	      expanded: _vm.showSingle
	    }
	  }, [(_vm.postJsonContentFeaturedImage) ? _c('div', {
	    staticClass: "singleContentInnerLeftLink",
	    style: ({
	      'height': _vm.linkLineHeight + 'px'
	    }),
	    attrs: {
	      "cameFromIndex": true
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        path: 'work/' + _vm.id,
	        query: {
	          yearview: _vm.index
	        }
	      }
	    }
	  }, [_c('span', [_vm._v("Read More")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "singleContentInner"
	  }, [_c('div', {
	    staticClass: "singleContentInnerFeatured"
	  }, [(_vm.postJsonContentFeaturedImage) ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.postJsonContentFeaturedImage),
	      expression: "postJsonContentFeaturedImage"
	    }],
	    style: ({
	      'height': _vm.featuredImageCalculatedHeight
	    })
	  }) : _vm._e(), _vm._v(" "), (_vm.postJsonContentFeaturedImage) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.postJsonContentFeaturedImageLoaded),
	      expression: "!postJsonContentFeaturedImageLoaded"
	    }],
	    staticClass: "loadingText"
	  }, [_c('span', [_vm._v("\n            LOADING\n          ")])]) : _vm._e()]), _vm._v(" "), (!_vm.postJsonContentFeaturedImage) ? _c('router-link', {
	    staticClass: "singleContentInnerLink",
	    style: ({
	      'border-top-color': _vm.yearColor
	    }),
	    attrs: {
	      "to": {
	        path: 'work/' + _vm.id,
	        query: {
	          yearview: _vm.index
	        }
	      }
	    }
	  }, [_c('span', [_vm._v("Read More")])]) : _vm._e(), _vm._v(" "), (_vm.postJsonContentFeaturedImage) ? [_c('div', {
	    staticClass: "singleContentInnerRenderedWrapper",
	    style: ({
	      'margin-bottom': _vm.linkLineHeight + 'px'
	    })
	  }, [_c('p', {
	    staticClass: "singleContentInnerRenderedFullTitle"
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.workstudent)
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.fulltitle)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "singleContentInnerRendered",
	    style: ({
	      background: _vm.yearColor
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.postJsonContent)
	    }
	  })])] : [_c('div', {
	    staticClass: "singleContentInnerRenderedWrapper"
	  }, [_c('p', {
	    staticClass: "singleContentInnerRenderedFullTitle"
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.workstudent)
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.fulltitle)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "singleContentInnerRendered",
	    domProps: {
	      "innerHTML": _vm._s(_vm.postJsonContent)
	    }
	  })])]], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "singlePostYear"
	  }, [(!_vm.singleLoaded) ? _c('div', {
	    staticClass: "singleLoaded"
	  }, [_c('h1', {
	    staticClass: "headerElement"
	  }, [_vm._v("Loading")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "signlePostHeader",
	    style: ({
	      'border-color': _vm.yearColor
	    })
	  }, [_c('span', {
	    staticClass: "headerElement",
	    style: ({
	      color: _vm.yearColor
	    }),
	    attrs: {
	      "id": "description"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "headerElement alignCenter",
	    style: ({
	      color: _vm.yearColor
	    }),
	    attrs: {
	      "id": "year"
	    }
	  }, [_vm._v("Year"), _c('br', {
	    staticClass: "tabletView"
	  }), _vm._v(" " + _vm._s(_vm.year))]), _vm._v(" "), (_vm.showIndexFirst) ? _c('span', {
	    staticClass: "headerElement alignRight",
	    style: ({
	      color: _vm.yearColor
	    })
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.goBack()
	      }
	    }
	  }, [_vm._v("Back")])]) : _c('span', {
	    staticClass: "headerElement alignRight",
	    style: ({
	      color: _vm.yearColor
	    })
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.goBackNone()
	      }
	    }
	  }, [_vm._v("Back")])])]), _vm._v(" "), _c('div', {
	    staticClass: "postcontentWrapper"
	  }, [_c('div', {
	    staticClass: "postcontentWrapperInner"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "postcontentWrapperTitle"
	  }, [_c('p', {
	    staticClass: "splashTitle",
	    style: ({
	      color: _vm.yearColor,
	      'border-color': _vm.yearColor
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.postJsonTitle)
	    }
	  })]), _vm._v(" "), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.postJsonContentMedia)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "right",
	    style: ({
	      background: _vm.yearColor
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.postJsonContent)
	    }
	  })]), _vm._v(" "), (_vm.postJsonContentFullSize) ? _c('div', {
	    staticClass: "postcontentFullSize",
	    style: ({
	      color: _vm.yearColor
	    })
	  }, [_c('div', {
	    staticClass: "fullSizeContent"
	  }, _vm._l((_vm.postJsonContentFullSize), function(img) {
	    return _c('img', {
	      style: ({
	        'max-width': img.width / img.height < 1 ? '40%' : ''
	      }),
	      attrs: {
	        "src": img.sizes.large
	      }
	    })
	  }))]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      expanded: _vm.expandedActive
	    },
	    attrs: {
	      "id": "meiaNews"
	    }
	  }, [_vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "newsInner"
	  }, [_c('p', [_vm._v("NEWS")]), _vm._v(" "), _c('p', [_vm._v("PRETTY FOOTER Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean nisi tellus, fermentum finibus lectus quis, interdum molestie leo. Morbi ultrices scelerisque lacus.")])])
	}]}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "footer"
	    }
	  }, [_c('div', {
	    staticClass: "footerContentWrapper"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('p', [_vm._v("ABOUT")]), _vm._v(" "), _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.about)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('p', [_vm._v("COLOPHON")]), _vm._v(" "), _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.colophon)
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "meiaAll"
	    }
	  }, [_c('meiaHeader', {
	    on: {
	      "emitToggleNews": function($event) {
	        _vm.toggleNews()
	      }
	    }
	  }), _vm._v(" "), _c('router-view', {
	    attrs: {
	      "loaded": _vm.loaded,
	      "showIndexFirst": _vm.showIndexFirst
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showIndex),
	      expression: "showIndex"
	    }]
	  }, [_c('Getgradyears')], 1), _vm._v(" "), _c('meiaFooter')], 1)
	},staticRenderFns: []}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "meiaHeader"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
	    staticClass: "headerElement alignCenter",
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('h1', {
	    attrs: {
	      "id": "meia"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "headerElement alignRight"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.goToBottom()
	      }
	    }
	  }, [_vm._v("ABOUT")])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "headerElement",
	    attrs: {
	      "href": "http://www.pzwart.nl/master-education-in-arts/"
	    }
	  }, [_c('h1', {
	    attrs: {
	      "id": "pzi"
	    }
	  })])
	}]}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.indexLoaded) ? _c('div', {
	    staticClass: "indexLoaded"
	  }, [_c('h1', {
	    staticClass: "headerElement"
	  }, [_vm._v("Loading")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "yearOuterWrapper"
	    }
	  }, _vm._l((_vm.gradyears), function(year, index) {
	    return _c('div', {
	      staticClass: "yearSingle",
	      class: {
	        slideOut: _vm.collapsed[index]
	      },
	      style: ({
	        color: year.acf.yearcolor
	      })
	    }, [_c('div', {
	      staticClass: "yearNavigation",
	      style: ({
	        'border-color': year.acf.yearcolor
	      })
	    }, [_c('div', [_vm._v(_vm._s(_vm.gradyears[index].slideoutactive))]), _vm._v(" "), _c('span', {
	      staticClass: "left",
	      on: {
	        "click": function($event) {
	          _vm.clickPrev(index)
	        }
	      }
	    }, [_vm._v("← Past")]), _vm._v(" "), _c('span', {
	      staticClass: "uppercase hoverYear",
	      on: {
	        "click": function($event) {
	          _vm.clickCollapseAll(index)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "ignoreTop"
	    }, [_vm._v("Year"), _c('br', {
	      staticClass: "tabletView"
	    }), _vm._v(" " + _vm._s(year.name))])]), _vm._v(" "), _c('span', {
	      staticClass: "right",
	      on: {
	        "click": function($event) {
	          _vm.clickNext(index)
	        }
	      }
	    }, [_vm._v("Future →")])]), _vm._v(" "), _c('Splashposts', {
	      attrs: {
	        "yearviewIndex": index,
	        "yearColor": year.acf.yearcolor,
	        "year": year.name,
	        "listpostId": 'listPosts' + year.name,
	        "categorylink": year._links['wp:post_type'][1].href
	      }
	    }), _vm._v(" "), _c('Listposts', {
	      style: ({
	        'background': year.acf.yearcolor
	      }),
	      attrs: {
	        "yearview": index,
	        "collapseAll": _vm.collapseAll,
	        "yearColor": year.acf.yearcolor,
	        "id": 'listPosts' + year.name,
	        "indexGradyears": index,
	        "categoryyear": year.name,
	        "categorylink": year._links['wp:post_type'][2].href
	      },
	      on: {
	        "stopIndexLoad": function($event) {
	          _vm.stopIndexLoad()
	        }
	      }
	    })], 1)
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.2a969bb61200437aa559.js